import type { ReactNode } from "react";

/** A key and its value in words (the shared `Row` sets values in the figure font, unwrapped). */
export function Line({ label, children }: { label: ReactNode; children: ReactNode }) {
  return (
    <div className="kv pf-line">
      <span className="kv-label">{label}</span>
      <span className="pf-line-value">{children}</span>
    </div>
  );
}

/** A Max chip beside a field's label. */
export function MaxChip({ onClick, disabled }: { onClick: () => void; disabled: boolean }) {
  return (
    <button type="button" className="chip pf-chip" onClick={onClick} disabled={disabled}>
      Max
    </button>
  );
}
